import { render, staticRenderFns } from "./BlocoInformacaoCertificacao.vue?vue&type=template&id=2bb426f6&lang=pug"
import script from "./BlocoInformacaoCertificacao.vue?vue&type=script&lang=js"
export * from "./BlocoInformacaoCertificacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoInformacaoCertificacao.vue?vue&type=style&index=0&id=2bb426f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports